// extracted by mini-css-extract-plugin
export default {"cta":"MN-z","disabled":"NN-z"};